import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { Subject, Observable, of } from 'rxjs';
import { Items } from '../models/items';
import { Transaction } from '../models/transaction';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { PaymentTransaction } from '../models/paymentTransaction';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentTransactionsService {

    constructor(
        private http: HttpClient,
        private configService: ConfigurationService,
        private notifService: NotifMessageService,
        private utilsService: UtilsService
    ) { }

    transactionSubject = new Subject<any[]>();
    transactionSubjectPager = new Subject<Items<any>>();

    emitTransactionPager(paymentTransaction) {
        this.transactionSubjectPager.next(paymentTransaction);
    }

    emitTransactionsByTransaction(criteria) {
        this.transactionSubject.next(criteria);
    }

    getPaymentTransactionById(id): Observable<PaymentTransaction> {
        return this.http.get<any>(`${this.configService.config.urlAPI.urlPaymentTransaction}/${id}`).pipe(catchError(err => {
            console.log("error", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
            let emptyItem = new PaymentTransaction();
            return of(emptyItem);
        }));
    }

    downloadFile(data, filename = 'data') {
        data = data.map(elt => {
            elt.merchantExtRef = elt.merchantRef;
            return elt;
        } )
        let csvData = this.convertToCSV(data);
        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    pay = new Object();

    convertToCSV(objArray) {
        this.pay = {
            id: "",
            transactionId: "",
            paymentMeanId: "",
            paymentId: "",
            externalId: "",
            orderId: "",
            maskedPan: "",
            walletId: "",
            merchantId: 0,
            merchantExtRef:"",
            endToEndId: "",
            authorizedAmount: 0,
            capturedAmount: 0,
            refundAmount: 0,
            currency: "",
            createdDate: "",
            completionDate: "",
            errorCode: "",
            status: "",
            paymentTransactionStatusHistory: [],
            paymentTransactionProvider: "",
            createdBy: "",
        };
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        const separator = ',';
        const keys = Object.keys(this.pay);
        const csvData =
            keys.join(separator) +
            '\n' +
            array.map(row => {
                return keys.map(k => {
                    let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                    if (cell instanceof Array && cell.length > 0) {
                        let values = cell.map(o => Object.values(o).join(',')).join('\t');
                        cell = values;
                    }
                    cell = cell instanceof Date
                        ? cell.toLocaleString()
                        : cell.toString().replace(/"/g, '""');

                    if (cell.search(/("|,|\n)/g) >= 0) {
                        cell = `"${cell}"`;
                    }
                    return cell;
                }).join(separator);
            }).join('\n');
        return csvData;
    }

    findByCriteria(criteria, pager): Observable<Items<PaymentTransaction>> {
        this.utilsService.updateCriteriaWindowFromTo(criteria);

        let params = {};
        Object.assign(params, pager, criteria);
        return this.http.get<any>(this.configService.config.urlAPI.urlPaymentTransaction, { params: params }).pipe(catchError(err => {
            console.log("error findBYCriteria", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
            let emptyList = new Items<Transaction>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }

    exportByCriteria(criteria, pager): Observable<Items<PaymentTransaction>> {
        this.utilsService.updateCriteriaWindowFromTo(criteria);

        let params = {};
        Object.assign(params, pager, criteria);
        return this.http.get<any>(`${this.configService.config.urlAPI.urlPaymentTransaction}/export`, { params: params }).pipe(catchError(err => {
            console.log("error exportBYCriteria", err);
            this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
            let emptyList = new Items<Transaction>();
            emptyList.content = [];
            return of(emptyList);
        }));
    }

}
